import { inferLiteral } from "client/utils"
import { SilProjectDevice } from "server/models"
import { SilDeviceType } from "client/store"
import * as types from "./types"


export const setSilUpdateDeviceTargetDevice = (device: SilProjectDevice) => ({
    type: inferLiteral(types.SIL_UPDATE_DEVICE_TARGET_DEVICE),
    device,
})
export const setSilUpdateDeviceOriginDevice = (device: SilProjectDevice) => ({
    type: inferLiteral(types.SIL_UPDATE_DEVICE_ORIGIN_DEVICE),
    device,
})


export const setSilUpdateDeviceTargetSubsystem = (device: SilDeviceType) => ({
    type: inferLiteral(types.SIL_UPDATE_DEVICE_TARGET_SUBSYSTEM),
    device,
})
export const setSilUpdateDeviceOriginSubsystem = (device: SilDeviceType) => ({
    type: inferLiteral(types.SIL_UPDATE_DEVICE_ORIGIN_SUBSYSTEM),
    device,
})
